
import { RevButton } from '@ds/components/Button'
import { RevIllustration } from '@ds/components/Illustration'

import translations from './Error.translations'

export default {
  components: {
    RevButton,
    RevIllustration,
  },
  props: {
    closeWording: {
      type: String,
      required: true,
    },
  },
  computed: {
    translations: () => translations,
  },
  mounted() {
    this.$emit('tracking', { type: 'error' })
  },
  methods: {
    handleClick() {
      this.$emit('completed', { to: 'close' })
    },
  },
}
